export default "__VITE_ASSET__NfdCYp7K__"